import React from 'react';
export const DressIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='8.069'
      height='16'
      viewBox='0 0 8.069 16'
    >
      <g data-name='Group 2483' transform='translate(0)'>
        <path
          data-name='Path 2037'
          d='M128.461,11.218c-.107-.534-.341-3.042-.9-3.875a1.286,1.286,0,0,1-.169-.714.035.035,0,0,0,0-.006c.018-.257.046-.531.065-.677,0-.026.007-.051.01-.067.014-.086.033-.171.051-.257h0a14.282,14.282,0,0,0,.458-2.441c0-1.27-.651-1.644-.651-1.644.224-.95.384-1.462.384-1.462L127.522,0a9.387,9.387,0,0,0-.427,1.526,2.588,2.588,0,0,1-1.921.619,2.59,2.59,0,0,1-1.921-.619A9.4,9.4,0,0,0,122.825,0l-.192.075s.16.512.384,1.462c0,0-.651.374-.651,1.644a13.042,13.042,0,0,0,.437,2.339.086.086,0,0,0,0,.035c0,.008.006.019.009.031l.006.024c.027.109.066.3.072.311.013.077.027.216.039.358.005.049.009.1.012.145.005.068.01.132.014.184h-.006a1.3,1.3,0,0,1-.17.735c-.555.833-.79,3.341-.9,3.874s-.363,2.5-.491,3.074-.256,1.367-.256,1.367a3.288,3.288,0,0,0,1.068.128s-.075.224.576.16a12.831,12.831,0,0,1,1.75-.054c.448.021.135.107.64.107s.192-.085.64-.107a12.79,12.79,0,0,1,1.751.054c.651.064.576-.16.576-.16a3.3,3.3,0,0,0,1.067-.128s-.128-.79-.256-1.367S128.568,11.752,128.461,11.218Zm-1.139-5.467c-.05.069-.094.177-.036.224-.015.1-.024.206-.034.309-.058-.066-.243-.006-.243-.006-.138-.06.121.3.226.161,0,.058-.006.115-.009.173-.126-.009-.253-.018-.38-.025a.586.586,0,0,0-.061-.133c.014-.1-.1.014-.134.122-.273-.011-.547-.016-.822-.018-.057-.068-.244-.007-.244-.007-.028-.012-.04-.007-.039.008h-.028a.13.13,0,0,0,.015-.059.135.135,0,0,0-.27,0,.133.133,0,0,0,.015.06c-.361,0-.721.012-1.081.021a.7.7,0,0,0-.037-.069c.012-.082-.065-.015-.112.073l-.184,0a.436.436,0,0,0,.1-.178c.137-.086-.384-.065-.241.134a.182.182,0,0,0,.045.046l-.151,0a.078.078,0,0,0,0-.109c-.121-.176-.212.084-.222.114l-.263.006c0-.024,0-.048,0-.072.065-.01.28-.273.075-.315a.151.151,0,0,0-.1,0c-.01-.115-.024-.229-.043-.342a.6.6,0,0,0,.052-.12c.06-.037,0-.054-.085-.046-.01-.044-.022-.087-.035-.13l.2,0a.135.135,0,1,0,.26.051.132.132,0,0,0-.012-.055l.926-.017a.085.085,0,0,0,0,.117c.127.177.217-.064.236-.122l.426,0c.066.084.2.175.246.038a.184.184,0,0,0,.008-.041c.208,0,.417,0,.624,0a.133.133,0,0,0-.03.082.135.135,0,1,0,.27,0,.132.132,0,0,0-.029-.08c.342.006.681.022,1.021.042-.1.013-.226.069-.147.179.143.2.241-.134.241-.134.026-.016.028-.029.016-.037l.091.006s0,.005.007.007C127.34,5.661,127.331,5.706,127.322,5.751Z'
          transform='translate(-121.139)'
          fill='currentColor'
        />
        <path
          data-name='Path 2038'
          d='M254.937,189.152c-.128.076.352.067.224-.119S254.937,189.152,254.937,189.152Z'
          transform='translate(-250.536 -182.787)'
          fill='currentColor'
        />
        <path
          data-name='Path 2039'
          d='M237.086,189.725c-.088.209.221.124.221.124C237.441,189.916,237.175,189.516,237.086,189.725Z'
          transform='translate(-233.276 -183.455)'
          fill='currentColor'
        />
        <path
          data-name='Path 2040'
          d='M246.479,182.469c-.253-.051-.088.275-.088.275C246.346,182.908,246.731,182.52,246.479,182.469Z'
          transform='translate(-242.24 -176.491)'
          fill='currentColor'
        />
        <path
          data-name='Path 2041'
          d='M274.916,173.035c.084-.231-.247-.122-.247-.122C274.521,172.847,274.832,173.266,274.916,173.035Z'
          transform='translate(-269.605 -167.228)'
          fill='currentColor'
        />
        <path
          data-name='Path 2042'
          d='M264.6,178.247c.245.021.054-.27.054-.27C264.673,177.816,264.35,178.226,264.6,178.247Z'
          transform='translate(-259.81 -172.115)'
          fill='currentColor'
        />
        <path
          data-name='Path 2043'
          d='M255.758,174.715c.143.2.241-.134.241-.134C256.136,174.495,255.615,174.515,255.758,174.715Z'
          transform='translate(-251.328 -168.82)'
          fill='currentColor'
        />
        <circle
          data-name='Ellipse 71'
          cx='0.135'
          cy='0.135'
          r='0.135'
          transform='translate(2.892 6.148)'
          fill='currentColor'
        />
        <path
          data-name='Path 2044'
          d='M218.467,182.406c-.128-.187-.224.119-.224.119C218.114,182.6,218.595,182.592,218.467,182.406Z'
          transform='translate(-215.043 -176.377)'
          fill='currentColor'
        />
        <path
          data-name='Path 2045'
          d='M219.072,192.782c-.148-.065.163.354.247.123S219.072,192.782,219.072,192.782Z'
          transform='translate(-215.828 -186.447)'
          fill='currentColor'
        />
        <path
          data-name='Path 2046'
          d='M199.506,183.093c-.088.209.221.124.221.124C199.86,183.284,199.594,182.885,199.506,183.093Z'
          transform='translate(-196.925 -177.041)'
          fill='currentColor'
        />
        <path
          data-name='Path 2047'
          d='M208.891,175.836c-.253-.051-.088.275-.088.275C208.758,176.276,209.143,175.887,208.891,175.836Z'
          transform='translate(-205.882 -170.076)'
          fill='currentColor'
        />
        <path
          data-name='Path 2048'
          d='M289.843,186.1a.135.135,0,1,1-.135.135A.135.135,0,0,1,289.843,186.1Z'
          transform='translate(-284.19 -180.009)'
          fill='currentColor'
        />
        <path
          data-name='Path 2049'
          d='M298.459,180.79c-.128.077.352.067.224-.119S298.459,180.79,298.459,180.79Z'
          transform='translate(-292.633 -174.698)'
          fill='currentColor'
        />
        <path
          data-name='Path 2050'
          d='M279.489,192.851c.143.2.241-.134.241-.134C279.867,192.631,279.346,192.651,279.489,192.851Z'
          transform='translate(-274.281 -186.362)'
          fill='currentColor'
        />
        <path
          data-name='Path 2051'
          d='M279.72,181.364c-.088.209.221.124.221.124C280.075,181.555,279.808,181.155,279.72,181.364Z'
          transform='translate(-274.514 -175.368)'
          fill='currentColor'
        />
        <path
          data-name='Path 2052'
          d='M289.113,174.1c-.253-.051-.089.275-.089.275C288.98,174.541,289.366,174.153,289.113,174.1Z'
          transform='translate(-283.478 -168.398)'
          fill='currentColor'
        />
        <path
          data-name='Path 2053'
          d='M228.78,171.616c.245.021.054-.27.054-.27C228.858,171.185,228.535,171.6,228.78,171.616Z'
          transform='translate(-225.167 -165.701)'
          fill='currentColor'
        />
        <path
          data-name='Path 2054'
          d='M193.371,173.035c.084-.231-.247-.122-.247-.122C192.976,172.847,193.287,173.266,193.371,173.035Z'
          transform='translate(-190.73 -167.228)'
          fill='currentColor'
        />
        <path
          data-name='Path 2055'
          d='M183.052,178.247c.245.021.054-.27.054-.27C183.13,177.816,182.807,178.226,183.052,178.247Z'
          transform='translate(-180.936 -172.115)'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};
